import { CompanyStatus } from "@/utils/enum";

export const statusToColor = {
  [CompanyStatus.Active]: "green",
  [CompanyStatus.Duplicate]: "orange",
  [CompanyStatus.Block]: "red",
  [CompanyStatus.MissingInfo]: "teal",
  [CompanyStatus.SoftBlock]: "purple",
};

export const statusToColorBackground = {
  [CompanyStatus.Active]: "green",
  [CompanyStatus.Duplicate]: "rgba(255, 165, 0, 0.15)",
  [CompanyStatus.Block]: "rgba(255, 0, 0, 0.15)",
  [CompanyStatus.MissingInfo]: "rgba(0, 128, 128, 0.15)",
  [CompanyStatus.SoftBlock]: "rgba(128, 0, 128, 0.15)",
};

export const statusToColorText = {
  [CompanyStatus.Active]: "green",
  [CompanyStatus.Duplicate]: "rgba(255, 165, 0, 0.75)",
  [CompanyStatus.Block]: "rgba(255, 0, 0, 0.75)",
  [CompanyStatus.MissingInfo]: "rgba(0, 128, 128, 0.75)",
  [CompanyStatus.SoftBlock]: "rgba(128, 0, 128, 0.75)",
};

export const statusToColorBorder = {
  [CompanyStatus.Active]: "green",
  [CompanyStatus.Duplicate]: "rgba(255, 165, 0, 0.75)",
  [CompanyStatus.Block]: "rgba(255, 0, 0, 0.75)",
  [CompanyStatus.MissingInfo]: "rgba(0, 128, 128, 0.75)",
  [CompanyStatus.SoftBlock]: "rgba(128, 0, 128, 0.75)",
};
